module.exports = __webpack_public_path__ + "static/media/touch-phone.23c14354.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/touch-phone.png
// module id = 371
// module chunks = 0